import React from 'react';
import PropTypes from 'prop-types';
import { queryString } from '../../utils';
import CTAButton from '../ctaButton/CTAButton';
import List from '../list/List';
import classNames from 'classnames';

const CTAWrapper = ({ cta }) => {
  if (!cta) return null;
  return cta.map((callToAction, i) => (
    <div key={`hb-button-wrap_${i}`} className="header-block__cta-wrapper">
      <CTAButton key={`hb-button_${i}`} {...callToAction} placement="page_header" />
    </div>
  ));
};

const HeaderBlock = ({
  title,
  preTitle,
  text,
  image,
  mobileImage,
  colour,
  callToAction,
  arrow,
  customPadding,
  dynamic,
  list
}) => {
  let params = dynamic && typeof window !== 'undefined' ? queryString(window.location.search) : {};
  let dynamicPreTitle = dynamic && params[dynamic.id] ? params[dynamic.id].replace(/_/g, ' ') : '';
  const scrollDown = (e) => {
    e.preventDefault();
    let arrowLink = `scroll-section`;
    if (arrow.link) arrowLink = arrow.link;
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: document.getElementById(arrowLink).offsetTop - 120
    });
  };

  const componentClasses = classNames('header-block', {
    [`header-block--${colour}`]: colour,
    [`header-block--${customPadding}`]: customPadding,
    [`header-block--mobile-image`]: mobileImage
  });

  return (
    <header className={componentClasses}>
      <div className="header-block__container">
        <div className={`header-block__content ${image.size ? `header-block__content--${image.size}-img` : ''}`}>
          {preTitle && <h2 className="header-block__pretitle">{`${preTitle} ${dynamicPreTitle}`}</h2>}
          <h1 className="header-block__title" dangerouslySetInnerHTML={{ __html: title }}></h1>
          {text && <p className="header-block__text">{text}</p>}
          {list && (
            <List icon="Tick" sectionClass="header-block__list" customPadding="no-padding">
              {list.map((text) => (
                <List.Item key={text} text={text} />
              ))}
            </List>
          )}
          <CTAWrapper cta={callToAction} />
        </div>
        <div
          className={`header-block__image ${image.size ? `header-block__image--${image.size}` : ''} ${
            image.roundedCorners ? 'header-block__image--rounded-corners' : ''
          }`}
        >
          <img src={image.src} alt={image.alt} className="header-block__image-desktop" />
          {mobileImage && <img src={mobileImage.src} alt={mobileImage.alt} className="header-block__image-mobile" />}
        </div>
      </div>
      {arrow && (
        <div className="header-block__button">
          <a href={arrow.link ? `#${arrow.link}` : `#scroll-section`} onClick={(e) => scrollDown(e)}>
            <span className="screen-reader-text">Skip to main content</span>
            <img
              className={`down-button${arrow.bkgColour ? ` down-button--bkg-${arrow.bkgColour}` : ''}`}
              alt="Down arrow"
              src={arrow.img}
            />
          </a>
        </div>
      )}
    </header>
  );
};

HeaderBlock.propTypes = {
  title: PropTypes.string.isRequired,
  preTitle: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    size: PropTypes.oneOf([null, 'full']),
    roundedCorners: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }).isRequired,
  mobileImage: PropTypes.shape({ src: PropTypes.string, alt: PropTypes.string }),
  colour: PropTypes.oneOf([
    'dark-navy',
    'light-grey',
    'neutral-navy',
    'pca-gradient',
    'homepage-gradient',
    'sand',
    'neutral-teal',
    'dark-teal'
  ]),
  callToAction: PropTypes.arrayOf(PropTypes.shape(CTAButton.propTypes)),
  arrow: PropTypes.shape({ bkgColour: PropTypes.oneOf(['purple', 'white']), img: PropTypes.string }),
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-top-bottom']),
  list: PropTypes.array
};

export default HeaderBlock;
